import { Injectable } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from './models/modal-options.model';
import { ModalContent } from './modal-content.component';
import { StandardModal } from './standard-modal.component';

@Injectable()
export class ModalService {

    private modalRef: NgbModalRef;

    constructor(private modalService: NgbModal) {
    }

    public showModal<TModal extends ModalContent>(modalType: any, options: ModalOptions): NgbModalRef {
        if (options === null) {
            let message: string = '"options" is null when creating a modal dialog.';
            throw message;
        }

        this.modalRef = this.modalService.open(modalType, { windowClass: 'in' });
        this.modalRef.componentInstance.modalOptions = options;
        this.modalRef.componentInstance.modalDialogInfo = this.modalRef;
        return this.modalRef;
    }

    public createStandardModal(options: ModalOptions): NgbModalRef {
        return this.showModal(StandardModal, options);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/modal.service.ts